<template>
  <div class="category-dishes-swiper">
    <h2>{{ title }}</h2>
    <swiper :options="swiperOptions" ref="mySwiper" class="dishes-slider">
      <swiper-slide v-for="dish in dishes" :key="dish.ID">
        <dish :dish="dish" />
      </swiper-slide>
      <div class="dishes-slider-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
  import Dish from '/src/components/Dish'

  export default {
    name: 'CategoryDishesSwiper',
    data () {
      return {
        swiperOptions: {
          slidesPerView: 'auto',
          spaceBetween: 0,
          pagination: {
            el: '.dishes-slider-pagination',
            clickable: false
          },
          loop: false,
          simulateTouch: true,
          speed: 500
        }
      }
    },
    components: {
      Dish
    },
    props: {
      title: {
        type: String,
        required: true
      },
      dishes: {
        type: Array,
        required: true
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CategoryDishesSwiper.vue